import axios from 'axios'
import JwtService from './jwtService'

export default function useJwt(axiosIns, jwtOverrideConfig) {
  const jwt = new JwtService(axiosIns ?? axios, jwtOverrideConfig)

  return {
    jwt,
  }
}
